import React, { useState, useEffect } from "react";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import Select from "react-select"; // Import react-select
import Sidebar from "../components/Sidebar";
import "./Editwidget.css";

import {
  GetwidgetById,
  EditWedgetAPI,
  GetProductStatus,
  GetPincodeProduct,
  GetProductCatWithoutPage,
  GetProductSubCatWithoutPage,
  EditWedgetProduct,
  GetPageNumber,
  api_url,
  updateProductsInWidget,
} from "../apiconfig/authService";

function EditWedget(props) {
  const navigate = useNavigate();
  const { id } = useParams();
  console.log("id????", id);
  const widgetid = id;
  const [message, setMessage] = useState("");
  const [isMessageRed, setIsMessageRed] = useState(false);
  const [editedEmployeeData, setEditedEmployeeData] = useState({});
  const [statusData, setStatusData] = useState([]);
  const [pagenumber, setPagenumber] = useState();
  const [product, setProduct] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [categoryID, setCategoryID] = useState(-1);
  const [subcategoryID, setSubcategoryID] = useState(-1);
  const [visibleSubcategories, setVisibleSubcategories] = useState([]);
  const [refetchData, setRefetchData] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const setProductViewMessage = props.setMessage;
  const [prevproduct, setPrevproduct] = useState([]);
  const [selectedWidgets, setSelectedWidgets] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [previouscategory, setPreviouscategory] = useState([]);
  const [previoustypecategory, setPrevioustypecategory] = useState();
  const [previoussubcategory, setPreviousSubcategory] = useState();
  const [position, setPosition] = useState();
  const [type, setType] = useState(null);
  const [isShowSelectedProducts, setIsShowSelectedProducts] = useState(false)

  console.log("previouscategory???????????", previouscategory);
  console.log("previoussubcategory???????????", previoussubcategory);
  // console.log("type???????", type);
  // console.log("pagenumber???????", pagenumber);
  // console.log("subcategoryID???????", subcategoryID);
  // console.log("searchproduct", search);
  console.log("prevproduct??????", prevproduct);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GetwidgetById(
          id,
          localStorage.getItem("accessToken")
        );
        const pageNumberData = await GetPageNumber(
          localStorage.getItem("accessToken")
        );
        setPrevproduct(response.data.widget.products);
        setEditedEmployeeData(response.data.widget);
        setType(response.data.widget.type)
        setPagenumber(pageNumberData.data);
        setPreviouscategory(response.data.categories)
        setPreviousSubcategory(response.data.subcategories)
        setPrevioustypecategory(response.data.widget.category)
        setSelectedWidgets(response.data.widget.pagenumber); // Pre-select page numbers
      } catch (error) {
        console.error("Error fetching widget data:", error);
      }
    };
    fetchData();
  }, [id]);

  // console.log("prevproduct?????????", prevproduct);
  useEffect(() => {
    (async () => {
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        const pagenumber = await GetPageNumber(
          localStorage.getItem("accessToken")
        );
        const productData = await GetPincodeProduct(
          // page,
          // itemsPerPage,
          search,
          localStorage.getItem("accessToken"),
          categoryID,
          subcategoryID
        );

        setProduct(productData.data.products.items); // Set products for multi-select
        setStatusData(statusResponse.data);
        setPagenumber(pagenumber.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [id, search, refetchData, categoryID, subcategoryID]);

  console.log("categoryID?????", categoryID)
  useEffect(() => {
    (async () => {
      const categoryResponse = await GetProductCatWithoutPage(
        localStorage.getItem("accessToken")
      );
      const subCategoryResponse = await GetProductSubCatWithoutPage(
        localStorage.getItem("accessToken")
      );
      setCategories(categoryResponse.data.categories);
      setSubcategories(subCategoryResponse.data.subcategories);
    })();
  }, []);
  const [productData, setProductData] = useState([]);
  const handleProductChange = (selectedOptions) => {
    // Update state with selected product details
    setProductData(
      selectedOptions.map((option) => ({
        value: option.value, // Product ID
        label: option.label, // Product name
        image: option.image, // Image URL
      }))
    );

    // Log the IDs of selected products
    console.log(
      "Selected Product IDs:",
      selectedOptions.map((option) => option.value)
    );

    // Log the full details of selected products
    console.log("Selected Product Details:", selectedOptions);
  };

  // console.log("productData??????", productData);
  const handleSubcategoryIDChange = (event) => {
    const selectedSubcategoryID = parseInt(event.target.value, 10);
    setSubcategoryID(selectedSubcategoryID);

    // Filter products based on the selected subcategory
    const products = product.filter(
      (product) => product.subcategoryid === selectedSubcategoryID
    );
    // console.log("Filtered Products:????????", products);
    setIsShowSelectedProducts(true)
    setProductData(
      products.map((product) => ({
        value: product.productid,
        label: product.name,
        image: product.image,
      }))
    );
  };

  const handleCategoryIDChange = (e) => {
    setCategoryID(Number(e.target.value));
    setSubcategoryID(-1);
    // setVisibleSubcategories(
    //   subcategories.filter((item) => item.categoryid === e.target.value)
    // );
    setPrevproduct([]);
    setPreviousSubcategory([])
  };

  const handleSearchBoxSubmit = (event) => {
    event.preventDefault();
    setPage(1);
    setRefetchData(!refetchData);
  };

  const productOptions = product.map((item) => ({
    value: item._id,
    label: item.name,
    image: item.imageurl,
    weight: item.weight,
  }));
  console.log("productOptions??????", productOptions);

  const handleRemoveProduct = async (productid) => {
    try {
      const widgetId = widgetid; // Use the current widget ID from `useParams`
      const response = await fetch(
        `https://scrapbackend.pikeazy.in/wedgetTitle/updateProductsToWidget/${widgetId}/products/${productid}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      if (response.ok) {
        // Successfully removed, update the UI
        setPrevproduct((prevProducts) =>
          prevProducts.filter((product) => product.productid !== productid)
        );
        setProductViewMessage("Product removed successfully!")
        setMessage("Product removed successfully!");
        setIsMessageRed(false);
        window.location.reload(); // Refresh the page
        // fetchData();
      } else {
        const errorData = await response.json();
        console.error("Error removing product:", errorData);
        setMessage("Failed to remove product. Please try again.");
        setIsMessageRed(true);
      }
    } catch (error) {
      console.error("Error during API call:", error);
      setMessage("An error occurred while removing the product.");
      setIsMessageRed(true);
    }
  };

  const handleRemoveCategory = async (categoryid) => {
    try {
      const id = widgetid; // Use the current widget ID from `useParams`
      console.log("widgetId", id, "categoryid", categoryid)
      // Make API call to remove the category
      const response = await fetch(
        `https://scrapbackend.pikeazy.in/wedgetTitle/removeCategoryFromWidget/${id}/category/${categoryid}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      console.log("responsecategorydelete", response)
      if (response.ok) {
        // Successfully removed, update the UI
        setPrevioustypecategory((prevCategorys) =>
          prevCategorys.filter((categoryid) => product.categoryid !== categoryid) // Adjusted key for categories
        );
        setProductViewMessage("Category removed successfully!")
        setMessage("Category removed successfully!");
        setIsMessageRed(false);
      } else {
        const errorData = await response.json();
        console.error("Error removing category:", errorData);
        setMessage("Failed to remove category. Please try again.");
        setIsMessageRed(true);
      }
    } catch (error) {
      console.error("Error during API call:", error);
      setMessage("An error occurred while removing the category.");
      setIsMessageRed(true);
    }
  };

  const handleSubmitClick = async (e) => {

    e.preventDefault(); // Prevent default form submission behavior

    try {
      setPrevproduct([]);
      // const categoryPayload =
      //   type === "category" ? selectedCategories : [categoryID];
      const OldcategoryId = previoustypecategory.map((item) => {
        return item._id
      })
      console.log("OldcategoryId?????????????", OldcategoryId)

      const categoryPayload =
        type === "category"
          ? (selectedCategories && selectedCategories.length > 0 ? selectedCategories : OldcategoryId) : [categoryID];

      // Destructure values from the editedEmployeeData
      const { _id: id, title, statusid, position, pagenumber } = editedEmployeeData;
      console.log("widget_id", editedEmployeeData);
      // Prepare payload for widget update
      const widgetUpdatePayload = {
        id, // Widget ID
        title, // Widget Title
        statusid, // Status ID
        type: type,
        pagenumber: pagenumber,
        category: type === "product" ? [] : categoryPayload,
        position: position,
      };

      // Call the API to update widget details
      const response = await EditWedgetAPI(
        widgetUpdatePayload,
        localStorage.getItem("accessToken")
      );

      // Handle success or failure of widget update
      if (response.status === 200) {
        setProductViewMessage("Widget updated successfully!")
        console.log("Widget updated successfully:", response);
        navigate("/wedget"); // Redirect to the widget page even without updating products
      } else {
        throw new Error("Failed to update widget");
      }

      // Extract selected product IDs from state
      const selectedProductIds = productData?.map(
        (product) => product.value // Use `value` for product ID
      );
      console.log("selectedProductIds??????", selectedProductIds)
      if (selectedProductIds.length > 0) {
        // Prepare payload for product update
        const productUpdatePayload = {
          widgetId: id, // Widget ID
          productIds: selectedProductIds, // Array of selected product IDs
        };

        // Log the payload for debugging
        console.log("Product Update Payload:", productUpdatePayload);

        // Call the API to update selected products
        const updateProductResponse = await updateProductsInWidget(
          productUpdatePayload,
          localStorage.getItem("accessToken")
        );

        // Handle success or failure of product update
        if (updateProductResponse.status === 200) {
          console.log("Products updated successfully:", updateProductResponse);
          setMessage("Widget and products updated successfully!");
          setProductViewMessage("Widget and products updated successfully!")
          setIsMessageRed(false);

          // Redirect or update UI upon success
          navigate("/wedget");
          window.scrollTo(0, 0);
        } else {
          throw new Error("Failed to update products");
        }
      } else {
        console.log("No products selected, skipping product update.");
        setMessage("Widget updated successfully, but no products selected.");
        setIsMessageRed(false);
        navigate("/wedget"); // Redirect to the widget page even without updating products
        window.scrollTo(0, 0);
      }
    } catch (err) {
      // Handle and log errors
      console.error("Error updating widget or products:", err);
      setIsMessageRed(true);
      setMessage(
        err.response?.data?.error ||
        "An error occurred. Please try again later."
      );
      window.scrollTo(0, 0);
    }
  };

  const handlePositionChange = (e) => {
    const value = parseInt(e.target.value, 10) || ""; // Allow empty string for controlled input
    if (value === "" || value >= 1) {
      setEditedEmployeeData({
        ...editedEmployeeData,
        position: value,
      });
    }
  };

  useEffect(() => {
    if (previouscategory?.length > 0) {
      const defaultCategoryID = previouscategory[0].categoryid;
      setCategoryID(defaultCategoryID); // Set the first previous category as default

      console.log("Default Category ID:", defaultCategoryID);

      // Filter subcategories associated with this default category
      const subcategoriesForCategory = subcategories.filter(
        (item) => item.categoryid === defaultCategoryID
      );

      setVisibleSubcategories(subcategoriesForCategory);
    }
  }, [previouscategory, subcategories]);

  // Combine and deduplicate previouscategory and categories
  const combinedOptions = [
    ...previouscategory.map((prevCat) => ({
      value: prevCat.categoryid,
      label: prevCat.name,
    })),
    ...categories.map((cat) => ({
      value: cat.categoryid,
      label: cat.name,
    })),
  ].reduce((uniqueOptions, item) => {
    if (!uniqueOptions.some((opt) => opt.value === item.value)) {
      uniqueOptions.push(item);
    }
    return uniqueOptions;
  }, []);

  useEffect(() => {
    if (previoussubcategory?.length > 0) {
      setSubcategoryID(previoussubcategory[0]?.subcategoryid);
    }
  }, [previoussubcategory]);

  // Safely combine and deduplicate subcategories
  const combinedSubcategories = [
    ...(previoussubcategory?.map((prevSub) => ({
      value: prevSub?.subcategoryid,
      label: prevSub?.name,
    })) || []),

    ...(visibleSubcategories?.map((subCat) => ({
      value: subCat?.subcategoryid,
      label: subCat?.name,
    })) || []),
  ].reduce((uniqueOptions, item) => {
    if (item && !uniqueOptions.some((opt) => opt.value === item.value)) {
      uniqueOptions.push(item);
    }
    return uniqueOptions;
  }, []);

  console.log("visibleSubcategories??????", visibleSubcategories)
  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Edit Widget</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/wedget" className="btn btn-primary px-4">
              View All
            </NavLink>
          </div>
        </div>

        {message && (
          <div
            style={{ color: isMessageRed ? "red" : "black" }}
            className="alert alert-primary"
            role="alert"
          >
            {message}
          </div>
        )}
        <div className="personal-info tab-pane active storetab">
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="title">Title</label>
              <input
                type="text"
                onChange={(e) =>
                  setEditedEmployeeData({
                    ...editedEmployeeData,
                    title: e.target.value,
                  })
                }
                value={editedEmployeeData.title || ""}
                className="form-control custom-input my-2"
                id="title"
                placeholder="Title"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Page Name</label>
              <Select
                isMulti
                options={pagenumber?.map((item) => ({
                  value: item.pagenumber,
                  label: item.pagename,
                }))}
                value={selectedWidgets
                  .map((pageNumber) => {
                    // Find the matching option for the selected page number
                    const option = pagenumber.find(
                      (item) => item.pagenumber === pageNumber
                    );
                    return option
                      ? { value: option.pagenumber, label: option.pagename }
                      : null;
                  })
                  .filter((option) => option !== null)} // Remove null entries
                onChange={(selectedOptions) => {
                  // Update the state with selected values
                  setSelectedWidgets(selectedOptions.map((option) => option.value));
                  setEditedEmployeeData((prevData) => ({
                    ...prevData,
                    pagenumber: selectedOptions.map((option) => option.value), // Adjust logic here if necessary
                  }));
                }}
                className="basic-multi-select my-3"
                classNamePrefix="select"
                placeholder="Select Widgets..."
              />
            </div>

            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <label htmlFor="floatingInput">Status</label>
              <select
                className="form-select custom-input"
                onChange={(e) =>
                  setEditedEmployeeData({
                    ...editedEmployeeData,
                    statusid: Number(e.target.value),
                  })
                }
                value={editedEmployeeData?.statusid || ""}
              >
                {statusData.map((item) => (
                  <option key={item.statusid} value={item.statusid}>
                    {item.status}
                  </option>
                ))}
              </select>
            </div>
            <div className="row">
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <label htmlFor="floatingInput">Type</label>
                <select
                  className="form-select custom-input my-2"
                  onChange={(e) => {
                    setType(e.target.value);
                    setEditedEmployeeData({
                      ...editedEmployeeData,
                      type: e.target.value,
                    });
                  }} // Update the 'type' state
                  value={editedEmployeeData?.type || ""} // Value should reflect the current 'type'
                >
                  <option value="" disabled>Select Type</option>
                  <option value="category" disabled>Category</option>
                  <option value="product" disabled>Product</option>
                </select>
              </div>

              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <label htmlFor="brandName">Position</label>
                <input
                  type="number"
                  value={editedEmployeeData.position || ""}
                  onChange={handlePositionChange}
                  className="form-control custom-input my-2"
                  id="widget"
                  placeholder="Enter Widget Position"
                  min={1}
                />
              </div>
            </div>
            <form className="sForm" onSubmit={handleSearchBoxSubmit}>
              <div className="row">
                {/* Category Dropdown */}
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <label htmlFor="floatingInput">Select Category</label>
                  {type === "category" ? (
                    <Select
                      isMulti
                      closeMenuOnSelect={false}
                      options={[
                        // Combine and deduplicate current categories and previous categories
                        ...categories.map((cat) => ({
                          value: cat._id, // Unique category ID
                          label: cat.name, // Displayed name
                        })),
                        ...(previoustypecategory?.map((prevCat) => ({
                          value: prevCat._id,
                          label: prevCat.name,
                        })) || []),
                      ].reduce((uniqueOptions, item) => {
                        // Deduplicate options by `value`
                        if (!uniqueOptions.some((opt) => opt.value === item.value)) {
                          uniqueOptions.push(item);
                        }
                        return uniqueOptions;
                      }, [])} // Ensure unique options
                      value={[
                        // Merge selected categories and previous categories
                        ...selectedCategories.map((categoryId) => {
                          const matchedCategory = [
                            ...(categories || []),
                            ...(previoustypecategory || []),
                          ].find((item) => item._id === categoryId);
                          return matchedCategory
                            ? { value: matchedCategory._id, label: matchedCategory.name }
                            : null;
                        }),
                        ...previoustypecategory.map((prevCat) => ({
                          value: prevCat._id,
                          label: prevCat.name,
                        })),
                      ].filter((item, index, self) =>
                        item && self.findIndex((v) => v.value === item.value) === index
                      )} // Deduplicate and remove null values
                      onChange={(selectedOptions) => {
                        // Map selected options to their values
                        const selectedValues = selectedOptions.map((option) => option.value);

                        // Update the state
                        setSelectedCategories(selectedValues);

                        console.log("Updated Selected Categories:", selectedValues);
                      }}
                      placeholder="Select Category"
                      className="custom-select my-2"
                    />
                  ) : (
                    <select
                      id="categorySelect"
                      className="form-select my-3"
                      value={categoryID}
                      onChange={handleCategoryIDChange}
                    >
                      <option value={-1}>Select a Category</option>

                      {/* Render Combined Options */}
                      {combinedOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  )}
                </div>

                {/* Subcategory Dropdown */}
                {/* {type !== "category" && categoryID !== -1 && (
                  <div className="form-group col-sm-12 col-lg-6 mb-3">
                    <label htmlFor="floatingInput">Sub Category</label>
                    <select
                      className="form-select my-3"
                      value={subcategoryID}
                      onChange={handleSubcategoryIDChange}
                      disabled={categoryID === -1}
                    >
                      <option value={-1}>Select a Subcategory</option>
                      
                      {combinedSubcategories
                        .sort((a, b) => a.label.localeCompare(b.label))
                        .map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                    </select>
                  </div>
                )} */}
              </div>
            </form>
            <div className="form-group col-sm-12 col-lg-12 mb-3">

              {type === "product" &&
                categoryID !== -1 &&
                ( // Ensure both category and subcategory are selected
                  <>
                    <label htmlFor="productSelect">Select Products</label>
                    {type === "product" &&
                      categoryID !== -1 &&
                      ( // Ensure both category and subcategory are selected
                        <>
                          <label htmlFor="productSelect">Select Products</label>
                          <Select
                            options={productOptions} // Pass the correctly structured productOptions
                            isMulti
                            onChange={handleProductChange} // Use onChange to handle selections
                            closeMenuOnSelect={false}
                            onInputChange={(inputValue) => setSearch(inputValue)} // Update search term on input change
                            filterOption={null} // Disable client-side filtering to rely on server-side filtering
                            getOptionLabel={(option) => (
                              <div style={{ display: "flex", alignItems: "center" }}>
                                <img
                                  src={option.image}
                                  alt={option.label}
                                  style={{ width: 20, height: 20, marginRight: 10 }}
                                />
                                <span>{option.label}</span>
                                <span style={{ color: "#757575", fontSize: "14px", marginLeft: "15px" }}>
                                  ({option.weight})
                                </span>
                              </div>
                            )}
                            getOptionValue={(option) => option.value} // Use the value property for unique identification
                            placeholder="Search and Select Products"
                          />
                        </>
                      )}
                  </>
                )}
            </div>
            {prevproduct && prevproduct.length > 0 ? (
              prevproduct.map((item) => (
                <div
                  key={item.productid}
                  className="position-relative d-inline-block m-3"
                  style={{ width: "70px", height: "70px" }}
                >
                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "5px",
                      fontSize: "12px",
                      whiteSpace: "nowrap",   // Prevents text from wrapping to the next line
                      overflow: "hidden",     // Hides overflowed text
                      textOverflow: "ellipsis", // Adds "..." when text overflows
                      width: "80px",          // Set width to control text overflow
                      margin: "0 auto",       // Centers the text under the image
                    }}
                  >
                    {item.name}
                  </p>
                  <img
                    src={item.imageurl}
                    alt={item.name || "Product Image"}
                    width="50"
                    height="50"
                    className="img-thumbnail"
                  />
                  <button
                    type="button"
                    className="btn btn-danger btn-sm position-absolute top-0 end-0"
                    style={{
                      borderRadius: "50%",
                      padding: "1px 4px",
                      transform: "translate(35%, -60%)",
                    }}
                    onClick={() => handleRemoveProduct(item._id)}
                  >
                    ✕
                  </button>
                </div>
              ))
            ) : (
              <p className="text-center">

              </p>
            )}

            {type === "category" && previoustypecategory && previoustypecategory.length > 0 ? (
              previoustypecategory.map((item) => (
                <div
                  key={item.categoryid}
                  className="position-relative d-inline-block m-1"
                  style={{ width: "70px", height: "70px" }}
                >
                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "5px",
                      fontSize: "12px",
                      whiteSpace: "nowrap",   // Prevents text from wrapping to the next line
                      overflow: "hidden",     // Hides overflowed text
                      textOverflow: "ellipsis", // Adds "..." when text overflows
                      width: "80px",          // Set width to control text overflow
                      margin: "0 auto",       // Centers the text under the image
                    }}
                  >
                    {item.name}
                  </p>
                  <img
                    src={`${api_url}/product/category/getCategoryImage/${item.image}`} // Ensure `imageurl` exists in the category data
                    alt={item.name || "Category Image"}
                    width="50"
                    height="50"
                    className="img-thumbnail"
                  />
                  <button
                    type="button"
                    className="btn btn-danger btn-sm position-absolute top-0 end-0"
                    style={{
                      borderRadius: "70%",
                      padding: "1px 4px",
                      transform: "translate(35%, -60%)",
                    }}
                    // Uncomment the line below and implement `handleRemoveCategory` if needed
                    onClick={() => handleRemoveCategory(item._id)}
                  >
                    ✕
                  </button>
                </div>
              ))
            ) : (
              <p className="text-center">
                {/* {type === "category"
                  ? "No categories available to display."
                  : "Please select a category to display images."} */}

              </p>
            )}

            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <button
                type="submit"
                onClick={handleSubmitClick}
                className="btn btn-primary save-btn text-uppercase px-4 my-3"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditWedget;
